import React from 'react'
import Page from 'layouts/Page'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import { HRIS_PATH } from 'enrollment-platform/pages/HRIS/constants'

function Layout({
  children,
  title,
  maxWidth,
}: {
  children: React.ReactNode
  title: string
  maxWidth?: string
}) {
  return (
    <Page
      title={title}
      maxWidth={maxWidth}
      breadcrumb={
        <BreadcrumbNav
          items={[
            { title: 'Home', path: `/` },
            { title: 'HRIS', path: HRIS_PATH },
            { title: 'API Visibility', path: `${HRIS_PATH}/api-visibility` },
            { title: title },
          ]}
        />
      }
    >
      {children}
    </Page>
  )
}

export default Layout
